import {
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Crani - Container Out',
    title_out_form: 'Crani - Form Container Out',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Crani',
        href: '/opc/eir/container-out',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    filter: null,
    filterOn: [],
    sortBy: 'id_crani_out',
    sortDesc: true,
    fields: [
      {
        key: 'created_at',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'shipper',
        label: 'Shipper',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'vessel_voy',
        label: 'Vessel/Voy',
        sortable: true,
      },
      {
        key: 'admin_crani',
        label: 'Admin',
        sortable: true,
      },
      {
        key: 'aksi',
      },
    ],
    search_container: '',
    search_cont: '',
    form: {
      booking: false,
      items: [],
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  detail(state) {
    return state.data.detail;
  },
};

export const mutations = {
  changeCraniOut(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async changeImageCrani({ commit, state }, payload) {
    commit('changeCraniOut', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload.form);
    commit('changeCraniOut', {
      loading: false,
    });

    if (!result.error) {
      let items = data.form.items || [];
      if (items[payload.index].photo_survey) {
        items[payload.index].photo_survey[payload.changeId] =
          result.data.object;
      }

      commit('changeCraniOut', {
        form: {
          ...data.form,
          items,
        },
      });
    }
  },

  async uploadImageCrani({ commit, state }, payload) {
    commit('changeCraniOut', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload.form);
    commit('changeCraniOut', {
      loading: false,
    });

    if (!result.error) {
      let items = data.form.items || [];
      let photo_survey = items[payload.index].photo_survey || [];
      photo_survey.push(result.data.object);
      items[payload.index].photo_survey = photo_survey;

      commit('changeCraniOut', {
        form: {
          ...data.form,
          items,
        },
      });
    }
  },

  async searchDataBooking({ commit, state }, payload = null) {
    commit('changeCraniOut', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/crani-out/booking`, payload);
    commit('changeCraniOut', {
      loading: false,
    });

    if (!result.error) {
      commit('changeCraniOut', {
        form: {
          ...data.form,
          ...result.data.object,
        },
      });

      return true;
    }

    return false;
  },

  async getContainerStock({ commit, state }) {
    commit('changeCraniOut', {
      loading: true,
    });

    const { data } = state;
    let id_principle = data.form.booking ? data.form.booking.id_principle : '';
    if (id_principle === '') {
      id_principle = data.form.id_principle || '';
    }

    let type_container = [];
    let size_container = [];

    if (data.form.pay_order && data.form.pay_order.length) {
      data.form.pay_order.map((item) => {
        if (!type_container.includes(item.cont_type)) {
          type_container.push(item.cont_type);
        }

        if (!size_container.includes(item.cont_size)) {
          size_container.push(item.cont_size);
        }
      });
    }

    let params = {
      q: data.search_cont,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      principle: id_principle,
      pay_order: type_container.join(','),
      pay_size: size_container.join(','),
      booking: 1,
      id_crani_out:
        data.form && data.form.id_crani_out ? data.form.id_crani_out : '',
    };

    let result = await ApiGetRequest(`opr/container/stock`, params);
    commit('changeCraniOut', {
      loading: false,
    });

    if (!result.error) {
      commit('changeCraniOut', {
        form: {
          ...data.form,
          containers: !result.error ? result.data.object : [],
        },
        total: result.data.total || 0,
      });

      return true;
    }

    return !result.error ? true : false;
  },

  async getDownloadFiles({ commit }, payload = null) {
    commit('changeCraniOut', {
      loading: true,
    });

    let result = await ApiPostRequest('opr/download', {
      ...payload,
    });

    commit('changeCraniOut', {
      loading: false,
    });
    if (result) {
      return result.data.object;
    }
  },

  async getListCraniOut({ commit, state }) {
    commit('changeCraniOut', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      container: data.search_container ? data.search_container : '',
    };

    let result = await ApiGetRequest(`opr/crani-out`, params);
    commit('changeCraniOut', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async createCraniOut({ commit, state, dispatch }) {
    commit('changeCraniOut', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/crani-out`, data.form);
    commit('changeCraniOut', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return result.data.object;
    }

    return false;
  },

  async updateCraniOut({ commit, state, dispatch }, payload = null) {
    commit('changeCraniOut', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(`opr/crani-out/${payload.id}`, data.form);
    commit('changeCraniOut', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return result.data.object;
    }

    return false;
  },

  async deleteCraniOut({ commit, dispatch }, payload = null) {
    commit('changeCraniOut', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/crani-out/${payload.id}`);
    commit('changeCraniOut', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return result.data.object;
    }

    return false;
  },

  async getDetailCraniOut({ commit, state }, payload = null) {
    commit('changeCraniOut', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/crani-out/${payload.id}`);
    commit('changeCraniOut', {
      loading: false,
    });

    if (!result.error) {
      commit('changeCraniOut', {
        form: {
          ...data.form,
          ...result.data.object,
        },
      });

      return true;
    }

    return !result.error ? true : false;
  },
};
